"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonPretendingToBeALink = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("../../../../../shared/core");
var LinkStyledButton = styled_components_1.default.button(function (_a) {
    var colors = _a.theme.colors;
    return "\n  background: transparent;\n  color: ".concat(colors.primary, ";\n  text-decoration: underline;\n  padding-left: 0;\n  padding-right: 0;\n  border: 0;\n  transition: none;\n\n  &:hover {\n    color: ").concat(colors.primaryAlt, ";\n    background: transparent;\n  }\n");
});
var ButtonPretendingToBeALink = function (props) {
    var DestructiveCTAButton = (0, core_1.useComponents)().DestructiveCTAButton;
    return react_1.default.createElement(LinkStyledButton, __assign({ as: DestructiveCTAButton }, props));
};
exports.ButtonPretendingToBeALink = ButtonPretendingToBeALink;
